import { createContext } from 'react';

export const { Provider, Consumer } = createContext({
  commenters: [],
  showAllAnnotations: false,
  image: '',
});

